import { BankResetItems } from "web/types/Banks";
import { IPaymentSettingsItem } from "web/types/Payment";

import { BANK_PAYMENTS_TYPE } from "../consts";

export const getResetDateTimeByBankId = (
  bankResets: BankResetItems
): Record<string, number> | null => {
  if (!bankResets?.length) {
    return null;
  }

  return bankResets.reduce<Record<string, number>>(
    (result, { pointsBankId, resetDateTime }) => {
      const timestamp = new Date(resetDateTime).getTime();
      const currentTimestamp = result[pointsBankId];

      if (currentTimestamp === undefined || timestamp < currentTimestamp) {
        // eslint-disable-next-line no-param-reassign
        result[pointsBankId] = timestamp;
      }

      return result;
    },
    {}
  );
};

const sortRuleReset = (
  firstPayment: IPaymentSettingsItem,
  secondPayment: IPaymentSettingsItem,
  context: { resetDateTimeByBankId?: Record<string, number> | null }
) => {
  const { resetDateTimeByBankId } = context;

  if (!resetDateTimeByBankId) {
    return 0;
  }

  if (
    firstPayment.type !== BANK_PAYMENTS_TYPE ||
    secondPayment.type !== BANK_PAYMENTS_TYPE
  ) {
    return 0;
  }

  const firstResetDateTime =
    resetDateTimeByBankId[firstPayment.code] ?? Infinity;
  const secondResetDateTime =
    resetDateTimeByBankId[secondPayment.code] ?? Infinity;

  if (firstResetDateTime < secondResetDateTime) {
    return -1;
  }

  if (firstResetDateTime > secondResetDateTime) {
    return 1;
  }

  return 0;
};

export default sortRuleReset;
